// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(9999)),
      BsCssJs$PrezzeeRibbon.backgroundColor(BsCssJs$PrezzeeRibbon.rgba(62, 119, 176, {
                NAME: "num",
                VAL: 0.1
              })),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.activeBlue),
      BsCssJs$PrezzeeRibbon.display("inlineFlex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.px(2), BsCssJs$PrezzeeRibbon.px(5)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(15)),
      BsCssJs$PrezzeeRibbon.unsafe("width", "max-content"),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.125)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1.5)),
      BsCssJs$PrezzeeRibbon.fontWeight("bold"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.alignSelf("center")]),
      BsCssJs$PrezzeeRibbon.selector("img", [BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(8))]),
      BsCssJs$PrezzeeRibbon.selector("p", [BsCssJs$PrezzeeRibbon.margin("zero")])
    ]);

var Styles = {
  wrapper: wrapper
};

function EmailSignUp__Success(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: wrapper
            });
}

var make = EmailSignUp__Success;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
